import { config } from 'variables/config';
import useDataFetching from './useDataFetching';

export const useGetAllRoles = () => {
  const [loadingR, errorR, roles, fetchDataU] = useDataFetching(`${config.app.api_url}/roles`);
  let rolesArray = [];
  roles?.data &&
    roles?.data?.map((role) => {
      rolesArray.push(role?.name);
    });
  return rolesArray;
};
